<app-menu></app-menu>
<mat-toolbar class="flexSpace" color="primary"> Test Static Images
  <button [ngClass]="selectedClass" mat-flat-button [matMenuTriggerFor]="testAreas">
    {{ selectedTestArea.toString() }}
  </button>
  <mat-menu style="display: flex; flex-direction: column" #testAreas="matMenu">
    <button *ngIf="user.hasEmbargoPermissions()" class="embargo" mat-menu-item
      (click)="selectTestArea(testArea.EMBARGO)">
      {{ testArea.EMBARGO.toString() }}
    </button>
    <button class="pre-prod" mat-menu-item (click)="selectTestArea(testArea.PREPROD)">
      {{ testArea.PREPROD.toString() }}
    </button>
    <button class="prod" mat-menu-item (click)="selectTestArea(testArea.PROD)">
      {{ testArea.PROD.toString() }}
    </button>
  </mat-menu>

</mat-toolbar>
<div *ngIf="isLoading" class="loading-container">
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</div>
<div style="margin: auto" *ngIf="!isLoading">
  <mat-card>
    <mat-card-content>
      <form [formGroup]="staticForm">
        <div layout="row">
          <div flex>
            <mat-button-toggle-group [(value)]="optionType" formControlName="optionType" multiple=false>
              <mat-button-toggle *ngFor="let item of optionTypes;" (change)="selectionChanged($event)"
                [value]="item">{{item}}</mat-button-toggle>
            </mat-button-toggle-group>
            <mat-radio-group formControlName="searchMode" #radioGroup="matRadioGroup">
              <mat-radio-button value="implicit" class="col-sm-1">Implicit</mat-radio-button>
              <mat-radio-button value="explicit" class="col-sm-1">Explicit</mat-radio-button>
            </mat-radio-group>
            <mat-checkbox formControlName="showImages" class="col-sm-1">Show images</mat-checkbox>
          </div>

          <div flex>
            <mat-form-field>
              <mat-label>Brand</mat-label>
              <input type="text" maxlength="10" minlength="2" matInput formControlName="brand"
                [matAutocomplete]="brand" />
              <mat-autocomplete #brand="matAutocomplete" (optionSelected)="onBrandSelected($event.option.value)">
                <mat-option *ngFor="let brand of brands" [value]="brand">{{ brand }}</mat-option>
              </mat-autocomplete>
            </mat-form-field>
            <mat-form-field>
              <mat-label>Model</mat-label>
              <input type="text" maxlength="4" minlength="4" matInput formControlName="model"
                [matAutocomplete]="model" />
              <mat-autocomplete #model="matAutocomplete" (optionSelected)="onCarlineSelected($event.option.value)">
                <mat-option *ngFor="let carLine of carlines" [value]="carLine">{{ carLine }}</mat-option>
              </mat-autocomplete>
            </mat-form-field>
            <mat-form-field>
              <mat-label>Major and minor indicator</mat-label>
              <input type="text" maxlength="2" minlength="2" matInput formControlName="majorMinor"
                [matAutocomplete]="majorMinor" />
              <mat-autocomplete #majorMinor="matAutocomplete"
                (optionSelected)="onMajorMinorSelected($event.option.value)">
                <mat-option *ngFor="let majorMinor of majorMinorIndicators" [value]="majorMinor">{{ majorMinor
                  }}</mat-option>
              </mat-autocomplete>
            </mat-form-field>
            <mat-form-field>
              <mat-label>Bodystyle</mat-label>
              <input type="text" minlength="2" maxlength="2" matInput formControlName="bodyStyle"
                [matAutocomplete]="bodyStyle" />
              <mat-autocomplete #bodyStyle="matAutocomplete">
                <mat-option *ngFor="let bodyStyle of bodyStyles" [value]="bodyStyle">{{ bodyStyle }}</mat-option>
              </mat-autocomplete>
            </mat-form-field>

            <button mat-raised-button color="primary" type="submit" (click)="onSubmit('ui')"
              style="margin-right: 10px;">
              Submit
            </button>
            <button mat-raised-button color="primary" type="submit" *ngIf="optionType !== 'Dimensions'"
              [disabled]="isPDFLoading" (click)="onSubmit('pdf')">
              <div layout="row">
                <span *ngIf="isPDFLoading">
                  <mat-progress-spinner style="float:left; margin: 5px;" [diameter]="20"
                    mode="indeterminate"></mat-progress-spinner>
                </span>
                <span>
                  PDF {{pdfExportType}} {{pdfExportBrand}} {{pdfExportModel}}
                </span>
              </div>
            </button>
          </div>
        </div>
      </form>

      <mat-card *ngIf="isSubmitted" class="mat-elevation-z0 card-padding">
        <div>
          <mat-form-field class="col-sm-11">
            <mat-label>Filter</mat-label>
            <input matInput (keyup)="applyFilter($event)" placeholder="Enter here text from any column" #input />
          </mat-form-field>
          <button mat-raised-button color="primary" (click)="exportTable()">
            Export to Excel
          </button>
        </div>

        <table id="staticImagesTableV2" mat-table [dataSource]="dataSource" matSort>
          <ng-container matColumnDef="imageName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Image Name</th>
            <td mat-cell *matCellDef="let row">{{ row.imageName }}</td>
          </ng-container>
          <ng-container matColumnDef="path">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Directory / Link</th>
            <td mat-cell *matCellDef="let row">
              <a target="blank" href="{{ row.url }}">{{ row.path }}</a>
            </td>
          </ng-container>
          <ng-container matColumnDef="url">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              Image
            </th>
            <td mat-cell *matCellDef="let row" class="static-image">
              <a *ngIf="showImages" target="blank" href="{{ row.url }}">
                <img [src]="row.url" /></a>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

          <!-- Row shown when there is no matching data. -->
          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" colspan="3">
              No data retrieved or no data matching the filter "{{
              input.value
              }}"
            </td>
          </tr>
        </table>
      </mat-card>
    </mat-card-content>
  </mat-card>
</div>